import styled from 'styled-components';

import {Device} from '../../../../constants';

const VBucksSectionContainer = styled.section`
  display: flex;
  width: 100%;
  min-height: 1000px;
  position: relative;
  align-items: center;
  justify-content: center;
  margin-bottom: -4em;
  padding: 2em 0;
  z-index: 100;

  .video .overlay {
    display: none;
  }

  @media screen and (min-width: 2200px) {
    min-height: 1200px;
    margin-bottom: -12em;
  }

  @media screen and ${Device.tablet} {
    min-height: 1100px;
    align-items: flex-start;
    padding-top: 6em;
  }

  @media screen and ${Device.mobileL} {
    min-height: 650px;
    align-items: flex-start;
    padding-top: 6em;
    margin-bottom: -7em;

    .video {
      background-size: 100%;
    }
  }
`;

export default VBucksSectionContainer;
